import React from 'react';

const contact = () => {
    const host = document.getElementsByTagName('base')[0].href;
    let returnFundingUrl = 'https://efile-dev.universalservice.org/EFilePayments/Webpay'; // default to dev
    
    if (host.startsWith("https://forms.universalservice.org")) {
        returnFundingUrl = 'https://efile.universalservice.org/EFilePayments/Webpay';
    } else if (host.startsWith("https://forms-uat.universalservice.org")) {
        returnFundingUrl = 'https://efile-uat.universalservice.org/EFilePayments/Webpay';
    } else if (host.startsWith("https://forms-test.universalservice.org")) {
        returnFundingUrl = 'https://efile-test.universalservice.org/EFilePayments/Webpay';
    } else if (host.startsWith("https://forms-dev.universalservice.org")) {
        returnFundingUrl = 'https://efile-dev.universalservice.org/EFilePayments/Webpay';
    }

    return (

        <div>
            <div className="indi-long-form-text h3">Payment Recovery Payments</div>
           
            <div className="indi-long-form-text">

                <a
                    className="indi-button indi-button--primary"
                    title="Return Funding (opens in new window)"
                    aria-label="Return Funding"
                    href={returnFundingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Return Funding
                </a>
            </div>
            <div className="indi-long-form-text">
                <span>Note: Make USF contributions by going to Manage FCC Forms 499.</span>
            </div>
            <div className="indi-long-form-text h3">Help?</div>
            <div className="indi-long-form-text">
                <strong>Send us a message</strong> <br />
                <span><a title="Send us a message (opens in new window)" aria-label="Send us a message" href="https://www.usac.org/about/contact-usac/" target="_blank">Click here</a></span> <br />
            </div>
            <div className="indi-long-form-text">
                <strong>Call us</strong> <br />
                <span>(888) 641-8722</span> <br />
            </div>
        </div>
    );
};

export default contact;
